"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimReportArchiveBlock = exports.InterimReportArchive = void 0;
const foundation_settings_1 = require("@episerver/foundation-settings");
const spa_core_1 = require("@episerver/spa-core");
const react_1 = __importStar(require("react"));
const YoutubeModal_1 = __importDefault(require("app/Components/Common/YoutubeModal/YoutubeModal"));
require("./ReportArchiveBlocks.scss");
const InterimReportArchive = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const [scrollPos, setScrollPos] = (0, react_1.useState)(0);
    const [leftActive, setLeftActive] = (0, react_1.useState)(false);
    const [rightActive, setRightActive] = (0, react_1.useState)(true);
    const scrollable = (0, react_1.useRef)(null);
    const scrollRefs = (0, react_1.useRef)([]);
    const years = (0, react_1.useRef)(null);
    const rows = [];
    const linkrows = [];
    let sortedLinks = [];
    const checkLinkActivity = (link, path) => {
        if (!link)
            return '';
        if (link === path)
            return 'active';
        let activeClass = '';
        return activeClass;
    };
    const handleManualScroll = (e) => {
        const pos = e.target.scrollLeft;
        let changed = false;
        scrollRefs.current.forEach(el => {
            if (el.childElementCount !== 0 && el.scrollLeft !== pos) {
                changed = true;
            }
        });
        if (changed && document.activeElement.tagName === 'A')
            setScrollPos(document.activeElement.offsetLeft);
    };
    (_b = (_a = props.documentRow) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.forEach(function (x, index) {
        sortedLinks = [].slice.call(x.documentList).sort((a, b) => {
            if (a.documentYear > b.documentYear) {
                return -1;
            }
            if (a.documentYear < b.documentYear) {
                return 1;
            }
        });
        const links = [];
        sortedLinks.forEach(function (link, index) {
            // create heading rows
            if (index < 11) {
                if (rows.filter(item => item.props.children === link.documentYear).length === 0) {
                    rows.push(react_1.default.createElement("div", { role: 'columnheader', className: 'col-link d-flex justify-content-center', key: x.title.replace(/[^a-z0-9]/gi, '') + link.documentYear + 'heading' }, link.documentYear));
                }
                // create links
                links.push(react_1.default.createElement(react_1.default.Fragment, { key: (x.title.replace(/[^a-z0-9]/gi, '') + link.documentYear + 'links') },
                    react_1.default.createElement("div", { className: 'visually-hidden', role: 'rowheader' }, x.title),
                    react_1.default.createElement("div", { className: 'col-link d-flex justify-content-center px-sm-8', role: 'cell' }, !x.isYoutube ?
                        react_1.default.createElement("div", { className: "row gx-8 gx-sm-7" },
                            react_1.default.createElement("a", { className: `col-3 ${checkLinkActivity(link.q1DocumentLink, props.path)}`, href: link.q1DocumentLink, download: link.q1DocumentLink != null && link.q1DocumentLink.split('/').pop().indexOf('.') > 0 ? link.q1DocumentLink.split('/').pop() : false, target: x.openInNewWindow ? '_blank' : '_self' },
                                react_1.default.createElement("span", null, "Q1")),
                            react_1.default.createElement("a", { className: `col-3 ${checkLinkActivity(link.q2DocumentLink, props.path)}`, href: link.q2DocumentLink, download: link.q2DocumentLink != null && link.q2DocumentLink.split('/').pop().indexOf('.') > 0 ? link.q2DocumentLink.split('/').pop() : false, target: x.openInNewWindow ? '_blank' : '_self' },
                                react_1.default.createElement("span", null, "Q2")),
                            react_1.default.createElement("a", { className: `col-3 ${checkLinkActivity(link.q3DocumentLink, props.path)}`, href: link.q3DocumentLink, download: link.q3DocumentLink != null && link.q3DocumentLink.split('/').pop().indexOf('.') > 0 ? link.q3DocumentLink.split('/').pop() : false, target: x.openInNewWindow ? '_blank' : '_self' },
                                react_1.default.createElement("span", null, "Q3")),
                            react_1.default.createElement("a", { className: `col-3 ${checkLinkActivity(link.q4DocumentLink, props.path)}`, href: link.q4DocumentLink, download: link.q4DocumentLink != null && link.q4DocumentLink.split('/').pop().indexOf('.') > 0 ? link.q4DocumentLink.split('/').pop() : false, target: x.openInNewWindow ? '_blank' : '_self' },
                                react_1.default.createElement("span", null, "Q4")))
                        :
                            react_1.default.createElement("div", { className: "row gx-8 gx-sm-7" },
                                react_1.default.createElement("a", { className: `col-3 ${link.q1DocumentLink ? 'text-black' : ''}`, role: `${link.q1DocumentLink ? 'button' : ''}`, onClick: () => props.openVideo(link.q1DocumentLink) },
                                    react_1.default.createElement("span", null, "Q1")),
                                react_1.default.createElement("a", { className: `col-3 ${link.q2DocumentLink ? 'text-black' : ''}`, role: `${link.q2DocumentLink ? 'button' : ''}`, onClick: () => props.openVideo(link.q2DocumentLink) },
                                    react_1.default.createElement("span", null, "Q2")),
                                react_1.default.createElement("a", { className: `col-3 ${link.q3DocumentLink ? 'text-black' : ''}`, role: `${link.q3DocumentLink ? 'button' : ''}`, onClick: () => props.openVideo(link.q3DocumentLink) },
                                    react_1.default.createElement("span", null, "Q3")),
                                react_1.default.createElement("a", { className: `col-3 ${link.q4DocumentLink ? 'text-black' : ''}`, role: `${link.q4DocumentLink ? 'button' : ''}`, onClick: () => props.openVideo(link.q4DocumentLink) },
                                    react_1.default.createElement("span", null, "Q4"))))));
            }
        });
        linkrows.push(react_1.default.createElement("div", { className: `row document-row px-0 pt-6 pt-sm-2 ${x.boldLine ? 'bold-line' : ''}`, key: x.title },
            react_1.default.createElement("div", { className: 'col-document px-0 pb-1 pb-sm-0', "aria-hidden": true },
                x.title,
                " ",
                x.externalIcon && react_1.default.createElement("span", { className: 'icon-external-link px-1 text-blue fw-bold' })),
            react_1.default.createElement("div", { className: 'col-arrow p-0', "aria-hidden": true }),
            react_1.default.createElement("div", { className: 'col-years px-0 d-flex align-items-center', role: 'rowgroup' },
                react_1.default.createElement("div", { ref: (element) => { scrollRefs.current[index] = element; }, className: 'row scrollable', onScroll: () => handleManualScroll(window.event), role: 'row' }, links)),
            react_1.default.createElement("div", { className: 'col-arrow p-0', "aria-hidden": true })));
    });
    function scrollLeft() {
        scrollPos - scrollable.current.clientWidth < 0 ? setScrollPos(0) : setScrollPos(scrollPos - scrollable.current.clientWidth);
    }
    function scrollRight() {
        if (scrollPos + scrollable.current.clientWidth < scrollable.current.scrollWidth) {
            setScrollPos(scrollPos + scrollable.current.clientWidth);
        }
        else {
            setScrollPos(scrollable.current.scrollWidth);
        }
    }
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        //update scroll
        scrollable.current.scrollTo(scrollPos, 0);
        scrollRefs.current.forEach(element => {
            element.scrollTo(scrollPos, 0);
        });
        if (years.current.clientWidth > scrollable.current.scrollWidth) {
            setRightActive(false);
            setLeftActive(false);
        }
        else {
            scrollPos === 0 ? setLeftActive(false) : setLeftActive(true);
            scrollPos < scrollable.current.scrollWidth - years.current.clientWidth ? setRightActive(true) : setRightActive(false);
        }
        return () => { isCancelled = true; };
    }, [scrollPos]);
    const forward = typeof ((_c = props.labels.nextText) === null || _c === void 0 ? void 0 : _c.value) === 'string' ? (_d = props.labels.nextText) === null || _d === void 0 ? void 0 : _d.value : props.labels.nextText;
    const back = typeof ((_e = props.labels.prevText) === null || _e === void 0 ? void 0 : _e.value) === 'string' ? (_f = props.labels.prevText) === null || _f === void 0 ? void 0 : _f.value : props.labels.prevText;
    return react_1.default.createElement("div", { className: 'mb-7 row' },
        react_1.default.createElement("div", { className: 'col-12', role: 'table' },
            react_1.default.createElement("div", { className: 'row heading-row py-3 py-sm-2' },
                react_1.default.createElement("div", { className: 'col-document p-0', "aria-hidden": true }),
                react_1.default.createElement("div", { className: 'col-arrow p-0 d-flex justify-content-end' },
                    react_1.default.createElement("button", { "aria-disabled": !leftActive, tabIndex: leftActive ? 0 : -1, className: leftActive ? 'active left d-flex' : 'left d-flex', onClick: () => scrollLeft() },
                        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11.301", height: "7.064", viewBox: "0 0 11.301 7.064" },
                            react_1.default.createElement("path", { d: "M8.473,5.65,4.236,1.414,0,5.65-1.414,4.236l5.651-5.65,5.651,5.65Z", transform: "translate(1.414 1.414)" })),
                        react_1.default.createElement("span", { className: 'visually-hidden' }, back))),
                react_1.default.createElement("div", { ref: years, className: 'col-years p-0 d-flex align-items-center', role: 'rowgroup' },
                    react_1.default.createElement("div", { ref: scrollable, className: 'row scrollable', role: 'row' }, rows)),
                react_1.default.createElement("div", { className: 'col-arrow p-0 d-flex' },
                    react_1.default.createElement("button", { "aria-disabled": !rightActive, tabIndex: rightActive ? 0 : -1, className: rightActive ? 'active right d-flex' : 'right d-flex', onClick: () => scrollRight() },
                        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11.301", height: "7.064", viewBox: "0 0 11.301 7.064" },
                            react_1.default.createElement("path", { d: "M8.473,5.65,4.236,1.414,0,5.65-1.414,4.236l5.651-5.65,5.651,5.65Z", transform: "translate(1.414 1.414)" })),
                        react_1.default.createElement("span", { className: 'visually-hidden' }, forward)))),
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement("div", { className: 'linktable col-12' }, linkrows))));
};
exports.InterimReportArchive = InterimReportArchive;
const InterimReportArchiveBlock = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const settings = (0, foundation_settings_1.useSettings)();
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settings.getContainerOnServer('LabelSettings'));
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [videoUrl, setVideoUrl] = (0, react_1.useState)();
    const styles = {};
    if (((_a = props.data.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) && props.data.backgroundColor.value !== '')
        styles.backgroundColor = props.data.backgroundColor.value;
    const closeVideo = () => {
        setShowModal(false);
    };
    const openVideo = (url) => {
        if (url) {
            setVideoUrl(url);
            setShowModal(true);
        }
    };
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        settings.getContainer('LabelSettings').then(x => {
            if (isCancelled)
                return;
            setLabelSettings(x);
        });
        return () => { isCancelled = true; };
    }, [props.lang]);
    let cssClasses = ['row', (_b = props.data.fontColor) === null || _b === void 0 ? void 0 : _b.value, (_c = props.data.bottomPadding) === null || _c === void 0 ? void 0 : _c.value, (_d = props.data.topPadding) === null || _d === void 0 ? void 0 : _d.value];
    const headingContent = ((_e = props.data.mainbody) === null || _e === void 0 ? void 0 : _e.value) != undefined && ((_f = props.data.mainbody) === null || _f === void 0 ? void 0 : _f.value) != ''
        && react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "mainbody", className: 'headingArea col-12 px-0 pb-8 pb-sm-6' });
    if (!labelSettings)
        return null;
    return react_1.default.createElement("div", Object.assign({ className: 'interimReportArchiveBlock', "data-glenabled": (_g = props.data.enableGlossary) === null || _g === void 0 ? void 0 : _g.value }, (((_h = props.data.blockLanguage) === null || _h === void 0 ? void 0 : _h.value) !== '' ? { lang: (_j = props.data.blockLanguage) === null || _j === void 0 ? void 0 : _j.value } : null)),
        react_1.default.createElement("div", { className: cssClasses.join(' '), style: styles },
            react_1.default.createElement("div", { className: 'col-12' },
                react_1.default.createElement("div", { className: 'row' }, headingContent),
                react_1.default.createElement(exports.InterimReportArchive, { documentRow: props.data.documentRow, path: props.path, labels: labelSettings, pagetitle: props.parentVar, openVideo: openVideo }))),
        react_1.default.createElement(YoutubeModal_1.default, { visible: showModal, videoId: videoUrl, closeButtonText: labelSettings.closeText.value, onHideModal: closeVideo, youtubeBlockedText: (_k = labelSettings.youtubeBlockedText) === null || _k === void 0 ? void 0 : _k.value, youtubeBlockedCookieSettingBtnText: (_l = labelSettings.youtubeBlockedCookieSettingBtnText) === null || _l === void 0 ? void 0 : _l.value }));
};
exports.InterimReportArchiveBlock = InterimReportArchiveBlock;
exports.default = exports.InterimReportArchiveBlock;
